const Footer = () => {
  return (
    <footer className="download-footer">
    <div className="footer-container">
      <div className="footer-info">
        <p>&copy; {new Date().getFullYear()} AI Meeting Pro. All rights reserved.</p>
      </div>
      <div className="footer-links">
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms of Service</a>
        <a href="/contact">Contact</a>
      </div>
    </div>
  </footer>
    )
}

export default Footer;